import React from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'moment-timezone'
import endpointForm from './endpointForm';

class Datepick extends React.Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangeString = this.handleChangeString.bind(this)
        this.textInput = HTMLInputElement

        let checkEndpointFrom = this.props.endpointFrom
        let changeModdifier = false

        if (checkEndpointFrom === "connections" || checkEndpointFrom === "datasources") {
            changeModdifier = "right"
        } else {
            changeModdifier = "bottom"
        }

        this.state = {
            stringDate: props.selected,
            processedDate: Date.parse(props.selected),
            endpointFormDate: changeModdifier,
            selectedDate: null
        }

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            stringDate: nextProps.selected,
            processedDate: Date.parse(nextProps.selected)
        })
    }

    handleChange(date, event) {

        try {

            let checkEndpointFrom = this.state.endpointFormDate

            let UTCDate = moment.utc(date)
            let UTCDateStr = UTCDate.format("YYYY-MM-DD HH:mm:ss")

            let nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set
            nativeInputValueSetter.call(this.textInput, UTCDateStr)

            var ev2 = new Event('input', { bubbles: true })

            this.textInput.dispatchEvent(ev2)

            this.setState({
                processedDate: date,
                stringDate: UTCDateStr,
                selectedDate: date
            })
        } catch(e) {

            console.log('datepick handleChange Error: ', e)
        }        

    }

    handleChangeString(event) {
        // this.setState({ stringDate: event.target.value })
        this.props.onChange(event)
    }

    render() {

        var {processedDate, selectedDate} = this.state
            // processedDate = Date.parse(processedDate) ? Date.parse(processedDate) : Date.parse(selectedDate)
        var { selected } = this.props
            selected = selected ? new Date(selected) : null
        return (
            <div className="test">
                <DatePicker
                    className={this.props.className || "form-control"}
                    selected={this.props.selected ? selected : processedDate}
                    onChange={this.handleChange}
                    popperPlacement={this.state.endpointFormDate + "-start"}
                    disabled={this.props.disabled}
                    dateFormat="MM-dd-yyyy"
                    popperPlacement="bottom-start"
                    placeholderText={this.props.placeholderText ? this.props.placeholderText : ''}
                    // popperModifiers={{
                    //     flip: {
                    //         behavior: ["bottom"] // don't allow it to flip to be above
                    //     },
                    //     preventOverflow: {
                    //         enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                    //     },
                    //     hide: {
                    //         enabled: false // turn off since needs preventOverflow to be enabled
                    //     }
                    // }}
                />
                <input type="text" className={`d-none ${this.props.className || "form-control"}`} onChange={this.handleChangeString} id={this.props.id} name={this.props.name} value={this.state.stringDate} ref={inp => { this.textInput = inp }} />
                <div className="invalid-feedback">
                    {this.props.error}
                </div>
            </div>
        )
    }
}

export default Datepick


// WEBPACK FOOTER //
// ./src/components/datepick.js